import { Box, Typography } from '@mui/material';

const Home = () => {
    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: { xs: 'column', md: 'row' },
                alignItems: 'center',
                justifyContent: 'space-between',
                height: '80vh',
                width: '100%',
                px: 8,
                boxSizing: 'border-box',
            }}
        >
            {/* Columna izquierda: Texto (logo) */}
            <Box
                sx={{
                    width: { xs: '100%', md: '50%' },
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    textAlign: 'center',
                }}
            >
                <Typography
                    sx={{ fontWeight: 'bold', fontSize: 70, color: '#000' }}
                >
                    Bienvenidos a
                </Typography>
                <Box
                    component="img"
                    src={require('../../../assets/images/logos/logo.png')}
                    alt="Logo"
                    sx={{
                        maxHeight: '100vh',
                        height: '15rem',
                        width: 'auto',
                        objectFit: 'contain',
                    }}
                />
            </Box>

            {/* Columna derecha: Imagen chica */}
            <Box
                sx={{
                    width: { xs: '100%', md: '50%' },
                    display: 'flex',
                    justifyContent: { xs: 'center' },
                    alignItems: 'flex-end',
                    pt: { xs: 0, md: 10 },
                }}
            >
                <Box
                    component="img"
                    src={require('../../../assets/images/logos/chica_01.png')}
                    alt="Chica"
                    sx={{
                        maxHeight: { xs: '60vh', md: '90vh' },
                        width: 'auto',
                        objectFit: 'contain',
                    }}
                />
            </Box>
        </Box>
    );
};

export default Home;
